"use client";

import { useTranslation } from "react-i18next";
import SectionContainer from "@/common/SectionContainer";

const NewsroomError = ({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <SectionContainer className="bg-[#f5f5f5] min-h-screen pt-20">
      <div className="text-[#222222] px-4 py-5 md:py-20">
        <div className="flex flex-col items-center justify-center py-20 space-y-6">
          <h2 className="text-2xl font-bold">{t("NEWSROOM_ERROR_TITLE")}</h2>
          <p className="text-gray-500 text-center">
            {t("NEWSROOM_ERROR_DESCRIPTION")}
          </p>
          <button
            onClick={reset}
            className="px-6 py-2.5 bg-[#2b7fff] text-white text-sm font-medium rounded-lg hover:bg-[#1a6ae8] transition-colors"
          >
            {t("NEWSROOM_ERROR_RETRY")}
          </button>
        </div>
      </div>
    </SectionContainer>
  );
};

export default NewsroomError;
